import axios from "axios";
import { fetchHomeFiles } from "./apiService";
import {
  fetchFilesRequest,
  updateHomeFiles,
  updateStarredFiles,
  updateDeletedFiles,
} from "../../Redux/Files/FileActions";

import {
  openSnackBar,
  closeSnackBar,
  setBarMessage,
} from "../../Redux/SnackBar/SnackBarActions";

export const openShortMSG = () => {
  return (dispatch) => {
    dispatch(openSnackBar());
  };
};

export const closeShortMSG = () => {
  return (dispatch) => {
    dispatch(closeSnackBar());
  };
};

export const uploadFile = (userId, file) => {
  return (dispatch) => {
    const data = new FormData();
    data.append("file", file);
    data.append("user", userId);
    console.log(data);
    axios
      .post("https://decloud-backend.ashusharmaprod.repl.co/upload", data)
      .then((res) => {
        dispatch(fetchFilesRequest());
        dispatch(fetchHomeFiles(userId));
        dispatch(setBarMessage(res.data.message));
      })
      .then(() => {
        dispatch(openSnackBar());
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const shareFile = (userId, deFileHash, partnerEmail) => {
  return (dispatch) => {
    // const data = new FormData();
    // data.append("user", userId);
    // data.append("deFileHash", deFileHash);
    // data.append("partnerEmail", partnerEmail);
    // console.log(data);
    axios
      .post("https://decloud-backend.ashusharmaprod.repl.co/action/share", {
        user: userId,
        deFileHash: deFileHash,
        partnerEmail: partnerEmail,
      })
      .then((res) => {
        dispatch(setBarMessage(res.data.message));
      })
      .then(() => {
        dispatch(openSnackBar());
      })
      .catch(function (error) {
        dispatch(setBarMessage(error.response.data.message));
        console.log(error);
      })
      .then(() => {
        dispatch(openSnackBar());
      });
  };
};

export const impHandler = (fileId, userId, fileData, page) => {
  return (dispatch) => {
    const markFileImp = fileData.map((file) => {
      if (file._id === fileId) {
        file.isImp = !file.isImp;
      }
      return file;
    });

    if (page === "home") {
      dispatch(updateHomeFiles(markFileImp));
    } else {
      dispatch(updateStarredFiles(markFileImp));
    }

    const impFile = fileData.find((file) => {
      return fileId === file._id;
    });

    console.log(impFile.ipfsHash);
    axios.post("https://decloud-backend.ashusharmaprod.repl.co/action/star", {
      user: userId,
      deFileHash: impFile.ipfsHash,
    });
  };
};

export const deleteHandler = (fileId, userId, fileData, page) => {
  return (dispatch) => {
    const updatedFileDataList = fileData.filter((file) => {
      return file._id !== fileId;
    });

    if (page === "home") {
      dispatch(updateHomeFiles(updatedFileDataList));
    } else if (page === "starred") {
      dispatch(updateStarredFiles(updatedFileDataList));
    } else if (page === "bin") {
      dispatch(updateDeletedFiles(updatedFileDataList));
    }

    const deletedFile = fileData.find((file) => {
      return fileId === file._id;
    });
    axios
      .post("https://decloud-backend.ashusharmaprod.repl.co/action/bin", {
        user: userId,
        deFileHash: deletedFile.ipfsHash,
      })
      .then((res) => {
        console.log(res);
      });
  };
};

export const deletePermanently = (fileId, userId, fileData) => {
  return (dispatch) => {
    const updatedFileDataList = fileData.filter((file) => {
      return file._id !== fileId;
    });

    dispatch(updateDeletedFiles(updatedFileDataList));

    const deletedFile = fileData.find((file) => {
      return fileId === file._id;
    });

    console.log(deletedFile.ipfsHash);
    axios
      .post("https://decloud-backend.ashusharmaprod.repl.co/action/delete", {
        user: userId,
        deFileHash: deletedFile.ipfsHash,
      })
      .then((res) => {
        dispatch(setBarMessage(res.data.message));
      })
      .then(() => {
        dispatch(openSnackBar());
      });
  };
};

export const restoreDeletedFile = (fileId, userId, fileData) => {
  return (dispatch) => {
    const updatedFileDataList = fileData.filter((file) => {
      return file._id !== fileId;
    });

    dispatch(updateDeletedFiles(updatedFileDataList));

    const restoredFile = fileData.find((file) => {
      return fileId === file._id;
    });

    console.log(restoredFile.ipfsHash);
    axios
      .post("https://decloud-backend.ashusharmaprod.repl.co/action/restore", {
        user: userId,
        deFileHash: restoredFile.ipfsHash,
      })
      .then((res) => {
        return res.data.message;
      });
  };
};

export const downloadFile = (ipHash, userId, name) => {
  return () => {
    fetch(
      `https://decloud-backend.ashusharmaprod.repl.co/download?user=${userId}&deFileHash=${ipHash}`
    ).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = name;
        a.click();
      });
    });
  };
};
